var map = {
	"./001.jpeg": 8448,
	"./002.jpeg": 6189,
	"./003.jpeg": 2226,
	"./004.jpeg": 9624,
	"./005.jpeg": 2482,
	"./006.jpeg": 7700,
	"./007.jpeg": 642,
	"./008.jpeg": 4816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;